import React, { useEffect, useState } from 'react'
import Layout from '../../components/Layout'
import { useGetAssignmentsMarkQuery, useUpdateAssignmentMarkMutation } from '../../features/assignment/assignment.Api'
import swal from 'sweetalert'

export default function AssignmentMark() {
    const { isSuccess: isSuccessFetchAssignmentMark, data: assignmentsMark } = useGetAssignmentsMarkQuery()
    const [updateAssignmentMark, { isSuccess: isSuccessUpdateAssignmentMark }] = useUpdateAssignmentMarkMutation()

    const [pendingAssignment, setPendingAssignment] = useState(0)
    const [sentAssignmentMark, setSentAssignmentMark] = useState(0)

    const [mark, setMark] = useState(100)

    useEffect(() => {
        if (isSuccessFetchAssignmentMark && assignmentsMark.length > 0) {
            const pendingAssignment = assignmentsMark.filter(assignment => assignment.status === "pending")
            setPendingAssignment(pendingAssignment?.length)

            const publishedAssignment = assignmentsMark.filter(assignment => assignment.status === "published")
            setSentAssignmentMark(publishedAssignment?.length)
        }
    }, [isSuccessFetchAssignmentMark, assignmentsMark])

    useEffect(() => {
        if (isSuccessUpdateAssignmentMark) {
            swal("Successful", "Update assignment mark successful", "success");
            setMark(0)
        }
    }, [isSuccessUpdateAssignmentMark])

    function handleUpdateMark(assignment) {
        updateAssignmentMark({ ...assignment, mark: Number(mark), status: "published" })
    }

    return (
        <Layout>
            <section className="py-6 bg-primary">
                <div className="mx-auto max-w-full px-5 lg:px-20">
                    <div className="px-3 py-20 bg-opacity-10">
                        <ul className="assignment-status">
                            <li>Total <span>{isSuccessFetchAssignmentMark && assignmentsMark?.length}</span></li>
                            <li>Pending <span>{pendingAssignment}</span></li>
                            <li>Mark Sent <span>{sentAssignmentMark}</span></li>
                        </ul>
                        <div className="overflow-x-auto mt-4">
                            <table className="divide-y-1 text-base divide-gray-600 w-full">
                                <thead>
                                    <tr>
                                        <th className="table-th">Assignment</th>
                                        <th className="table-th">Date</th>
                                        <th className="table-th">Student Name</th>
                                        <th className="table-th">Repo Link</th>
                                        <th className="table-th">Mark</th>
                                    </tr>
                                </thead>

                                <tbody className="divide-y divide-slate-600/50">
                                    {
                                        isSuccessFetchAssignmentMark && assignmentsMark.length > 0 ? assignmentsMark.map(assignment => <tr key={assignment.id}>
                                            <td className="table-td">{assignment.title}</td>
                                            <td className="table-td">10 Mar 2023 10:58:13 PM</td>
                                            <td className="table-td">{assignment.student_name}</td>
                                            <td className="table-td">{assignment.repo_link}</td>

                                            {assignment.mark === 0 ?
                                                <td className="table-td input-mark">
                                                    <input type='text' max={100} min={0} onChange={e => setMark(e.target.value)} value={mark} />
                                                    <button onClick={() => handleUpdateMark(assignment)}>
                                                        <svg fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor"
                                                            className="w-6 h-6 text-green-500 cursor-pointer hover:text-green-400">
                                                            <path strokeLinecap="round" strokeLinejoin="round"
                                                                d="M4.5 12.75l6 6 9-13.5" />
                                                        </svg>
                                                    </button>

                                                </td> : <td className="table-td">{assignment.mark}</td>

                                            }
                                        </tr>) : <tr className='text-2xl'>No assignments mark found.</tr>
                                    }

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </section></Layout>
    )
}
